import { NextPage } from 'next'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { getLPs } from '~/apis'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import TipLink from '~/components/TipLink'
import { LOCALES } from '~/locales'
import { ClosedLPCard } from './components'
import { formatLPs, getClosedPolls } from './helpers'
import {
  StyledLonPageHelper,
  StyledLpWrapper,
  StyledCloseDivider,
} from './styled'

const LiquidityMining: NextPage = () => {
  const { i18n, t } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH

  const { data } = useSWR('getLPs', getLPs)
  const pools = data?.pools ? formatLPs(data?.pools) : []
  const closedPools = getClosedPolls(pools)
  const lpMiningEnded = pools.every((t) => t.closed)

  const tipsLink = isZh
    ? 'https://support.tokenlon.im/hc/zh-cn/articles/4412082111124#h_01FP4H6NP3NJ0N38ZFBEA9D992'
    : 'https://support.tokenlon.im/hc/en-us/articles/4412082111124#h_01FP4HAP1E7B4DTEEVFD3B1RZS'

  return (
    <StyledLonPageHelper>
      <Head>
        <title>{t('meta_lon_liquidity_title')}</title>
        <meta
          name="description"
          content={t('meta_lon_liquidity_description')}
        />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledLpWrapper>
        <div className="normal-wrap max-w-755">
          <TipLink href={tipsLink}>{t('lp_tips')}</TipLink>
          <StyledCloseDivider>
            <div />
            <p>{t('closed_pools')}</p>
            <div />
          </StyledCloseDivider>
          <div className="lp-selectors">
            {closedPools.map((lp, idx) => (
              <ClosedLPCard
                finalLP={lpMiningEnded ? idx === 0 : false}
                lp={lp}
                key={idx}
                index={idx}
                length={closedPools.length}
              />
            ))}
          </div>
        </div>
      </StyledLpWrapper>
      <Footer />
    </StyledLonPageHelper>
  )
}

export default LiquidityMining
